import { PERSONAL_AREA } from '@convenia/common-organisms/SystemFields/content/consts'
import { pickSection } from '@convenia/employee-organisms/SystemFields/helpers'

export const mapSystemFields = (data = []) => ({
  personal: pickSection(data, PERSONAL_AREA.PERSONAL, 'systemFields') || {},
  foreign: pickSection(data, PERSONAL_AREA.FOREIGN, 'systemFields') || {},
  bankAccounts: pickSection(data, PERSONAL_AREA.BANK_ACCOUNTS, 'systemFields') || {},
  educations: pickSection(data, PERSONAL_AREA.EDUCATIONS, 'systemFields') || {},
  handicap: pickSection(data, PERSONAL_AREA.HANDICAP, 'systemFields') || {},
})

export const mapCustomFields = (data = []) => ({
  personal: pickSection(data, PERSONAL_AREA.PERSONAL, 'customFields') || {},
  foreign: pickSection(data, PERSONAL_AREA.FOREIGN, 'customFields') || {},
  bankAccounts: pickSection(data, PERSONAL_AREA.BANK_ACCOUNTS, 'customFields') || {},
  educations: pickSection(data, PERSONAL_AREA.EDUCATIONS, 'customFields') || {},
  handicap: pickSection(data, PERSONAL_AREA.HANDICAP, 'customFields') || {},
})
